<template>
  <div style="margin-bottom: 24px;">
    <div style="display: flex; justify-content: space-around">
      <el-scrollbar height="480px" class="showBox">
        <p style="margin-bottom: 16px;">展示平台</p>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">鸿蒙平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateHm" v-model="checkAllHm" @change="hmHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedHm" @change="hmHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in channelListHm" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-bottom: 16px;padding-bottom: 16px; border-bottom: 1px solid #ededed;">
          <label style="font-weight: bold;margin-bottom: 8px;">IOS平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateIos" v-model="checkAllIos" @change="iosHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedIos" @change="iosHandleCheckedChange" style="display: block;">
            <el-checkbox v-for="item in channelListIos" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div>
          <label style="font-weight: bold;margin-bottom: 8px;">Android平台：</label>&nbsp;
          <el-checkbox :indeterminate="isIndeterminateAndroid" v-model="checkAllAndroid" @change="androidHandleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedAndroid" @change="androidHandleCheckedChange">
            <el-checkbox v-for="item in channelListAndroid" :label="item" :key="item" style="margin:0;width:33%;" size="small"></el-checkbox>
          </el-checkbox-group>
        </div>
      </el-scrollbar>
      <div style="width: 500px;">
        <el-form ref="formRef" :model="iconForm" label-width="114px">
          <el-form-item label="图标：">
            <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
            <div class="add" @click="headImgUpdate" v-else>
              <span>+</span>
            </div>
            <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
          </el-form-item>
          <el-form-item label="名称：">
            <el-input v-model="iconForm.name" placeholder="请输入名称" style="width:24em;"/>
          </el-form-item>
          <el-form-item label="跳转类型：">
            <el-select v-model="jumpType" placeholder="Select" style="width: 24em">
              <el-option v-for="item in jumpTypeArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转地址：" v-if="jumpType != 3">
            <el-input v-model="iconForm.jumpUrl" style="width:24em;" placeholder="请输入需要跳转的链接"></el-input>
          </el-form-item>
          <el-form-item label="跳转地址：" v-else>
            <el-select v-model="appUrl" placeholder="请选择" style="width: 24em;">
              <el-option v-for="item in appUrlArray" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序：">
            <el-input v-model="iconForm.showOrder" placeholder="排序，越大越靠前" style="width:24em;"/>
          </el-form-item>
          <el-form-item label="城市地区：">
            <div>
              <div style="display: flex; margin-bottom: 14px;">
                <ElButtons icon="Plus" v-if="checkArea" :disabled="checkArea">添加城市</ElButtons>
                <Area v-else title="" @areaChang='getArea($event)' @areaList="getAreaList($event)"/>
                <el-checkbox class="check" v-model="checkArea" @change="noArea()" style="margin-left: 12px;">不限城市</el-checkbox>
              </div>
              <div class="item-list" v-if="selectProvinces.length > 0">
                <div v-for="(value, index) in selectProvinces" :key="index" @click="delProvinces(index)" class="citys">
                  {{ value }}<ElIcons name="CircleCloseFilled" />
                </div>
              </div>
              <div class="item-list" v-if="selectCitys.length > 0">
                <div v-for="(value, index) in selectCitys" :key="index" @click="delCity(index)" class="citys">
                  {{ value }}<ElIcons name="CircleCloseFilled" />
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" style="text-align: center;">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { imgPostFormData, getFormData } from "@/api/api"
import { addOrUpdateHomeIcon, getAllChannelList } from "@/api/url";
import { urlReg } from "../../../assets/shared/reg-constant";
import Area from '@/components/AreaSelect'

export default {
  name: "GiftManageDialog",
  components: { Area },
  props: {
    value: Object
  },
  data() {
    return {
      iconForm: this.value.iconForm,
      idx: this.value.ids,
      loading: false,

      //跳转类型
      jumpTypeArray: [
        {label: "跳转到内部浏览器",value: 1},
        {label: "跳转到外部浏览器",value: 2},
        {label: "跳转到原生页面",value: 3}
      ],
      jumpType: this.value.iconForm.urlType?this.value.iconForm.urlType:1,
      //原生页面
      appUrlArray: [
        {label: "三行情书",value: '1'},
        {label: "发现页",value: '2'},
        {label: "小纸条",value: '3'},
        {label: "红娘牵线服务",value: '4'},
        {label: "星级特权",value: '5'},
        {label: "最近访问",value: '6'},
        {label: "邀请认证",value: '7'},
        {label: "微信下载记录",value: '8'},
        {label: "心动列表",value: '9'},
        {label: "对你感兴趣的人",value: '10'},
        {label: "微信审核",value: '11'},
        {label: "视频认证",value: '12'},
        {label: "身份认证",value: '13'},
        {label: "职业认证",value: '14'},
        {label: "学历认证",value: '15'},
        {label: "车辆认证",value: '16'},
        {label: "房屋认证",value: '17'},
        {label: "信息置顶",value: '18'},
        {label: "微信设置 ",value: '19'},
        {label: "编辑沟通用语",value: '20'},
        {label: "新消息通知",value: '21'},
        {label: "意见反馈",value: '22'},
        {label: "黑名单",value: '23'},
        {label: "关于我们",value: '24'},
        {label: "达人排行榜",value: '25'},
      ],
      appUrl: this.value.iconForm.urlType == 3?this.value.iconForm.jumpUrl:'1',

      files: null,
      src: this.value.ids > -1?this.value.iconForm.picture:'',


      //IOs渠道列表
      channelListIos: [],
      checkAllIos: true,
      checkedIos: [],
      isIndeterminateIos: false,

      //Android渠道列表
      channelListAndroid: [],
      checkAllAndroid: true,
      checkedAndroid: [],
      isIndeterminateAndroid: false,

      //Hm渠道列表
      channelListHm: [],
      checkAllHm: true,
      checkedHm: [],
      isIndeterminateHm: false,

      hmArray:[],
      iosArray:[],
      androidArray: [],

      // 城市
      checkArea: false,
      homeProvince: '',
      homeCity: '',
      selectCitys: [],
      selectProvinces: [],
      areaList: [],

    }
  },
  methods: {

    getAreaList(el) {
      this.areaList = el
    },
    // 现居城市
    getArea(el) {
      this.homeProvince = el.prov;
      this.homeCity = el.city;
      if(this.homeCity && this.homeCity == '不限'){
        let p = this.selectProvinces.indexOf(this.homeProvince);
        if(p == -1){
          this.selectProvinces.push(this.homeProvince)
          this.delCityFromPro(this.homeProvince)
        }else{
          this.$message({
            message: '你已经添加了该省份',
            type: "error"
          });
        }
      }
      if(this.homeCity && this.homeCity != '不限'){
        let p = this.selectProvinces.indexOf(this.homeProvince)
        if( p > -1) {
          this.selectProvinces.splice(p,1)
        }
        let c = this.selectCitys.indexOf(this.homeCity);
        if(c == -1){
          this.selectCitys.push(this.homeCity)
        }else{
          this.$message({
            message: '你已经添加了该城市',
            type: "error"
          });
        }
      }
    },

    delProvinces(index){
      this.selectProvinces.splice(index,1);
    },

    delCity(index){
      this.selectCitys.splice(index,1);
    },

    delCityFromPro(pro) {
      for(let i=0; i<this.areaList.length; i++) {
        if ( this.areaList[i].province == pro ) {
          let array = []
          this.areaList[i].cityList.map(item => {
            array.push(item.city)
          })
          for(let i=this.selectCitys.length-1; i >= 0; i--) {
            let j = array.indexOf(this.selectCitys[i])
            if( j > -1){
              this.selectCitys.splice(i,1)
            }
          }
        }
      }
    },

    noArea(){
      this.selectCitys = [];
      this.selectProvinces = [];
    },

    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },


    //hm
    hmHandleCheckAllChange(val) {
      this.checkedHm = val ? this.channelListHm : [];
      this.isIndeterminateHm = false;
      this.hmArray = [];
    },
    hmHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllHm = checkedCount === this.channelListHm.length;
      this.isIndeterminateHm = checkedCount > 0 && checkedCount < this.channelListHm.length;
      this.hmArray = [];
      for(let i=0;i<checkedCount;i++){
        // let hmStr = '4||';
        // hmStr += value[i];
        this.hmArray.push(value[i]);
      }
    },

    //ios
    iosHandleCheckAllChange(val) {
      this.checkedIos = val ? this.channelListIos : [];
      this.isIndeterminateIos = false;
      this.iosArray = [];
    },
    iosHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllIos = checkedCount === this.channelListIos.length;
      this.isIndeterminateIos = checkedCount > 0 && checkedCount < this.channelListIos.length;
      this.iosArray = [];
      for(let i=0;i<checkedCount;i++){
        // let iosStr = '2||';
        // iosStr += value[i];
        this.iosArray.push(value[i]);
      }
    },
    //Android
    androidHandleCheckAllChange(val) {
      this.checkedAndroid = val ? this.channelListAndroid : [];
      this.isIndeterminateAndroid = false;
      this.androidArray = [];
    },
    androidHandleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAllAndroid = checkedCount === this.channelListAndroid.length;
      this.isIndeterminateAndroid = checkedCount > 0 && checkedCount < this.channelListAndroid.length;
      this.androidArray = [];
      for(let i=0;i<checkedCount;i++){
        // let androidStr = '1||';
        // androidStr += value[i];
        this.androidArray.push(value[i]);
      }
    },

    //获取所有渠道列表
    getChannelListAll() {
      let _this = this;
      getFormData( getAllChannelList ).then((data) => {
        if(data.code == 200){
          for(let item of data.data) {
            if(item.platformType == 4) {
              _this.channelListHm.push(item.channel);
            }
            if(item.platformType == 2) {
              _this.channelListIos.push(item.channel);
            }
            if(item.platformType == 1) {
              _this.channelListAndroid.push(item.channel);
            }
          }
          if(_this.idx > -1) {
            _this.getChannelList();
          }else{
            _this.checkedHm = _this.channelListHm;
            _this.checkedIos = _this.channelListIos;
            _this.checkedAndroid = _this.channelListAndroid;
          }
        }
      })
    },

    //获取banner对应列表
    getChannelList() {
      for(let item of this.iconForm.harmonyChannelList) {
        if(item != -1) {
          this.checkedHm.push(item);
          this.hmHandleCheckedChange(this.checkedHm);
        }else if(item == -1){
          this.checkedHm = this.channelListHm;
          this.checkAllHm = true;
        }else if(this.checkedHm.length == 0){
          this.checkAllHm = false;
        }
      }
      if(this.iconForm.harmonyChannelList.length == 0) {
        this.checkAllHm = false;
      }
      for(let item of this.iconForm.iosChannelList) {
        if(item != -1) {
          this.checkedIos.push(item);
          this.iosHandleCheckedChange(this.checkedIos);
        }else if(item == -1){
          this.checkedIos = this.channelListIos;
          this.checkAllIos = true;
        }else if(this.checkedIos.length == 0){
          this.checkAllIos = false;
        }
      }
      if(this.iconForm.iosChannelList.length == 0) {
        this.checkAllIos = false;
      }
      for(let item of this.iconForm.androidChannelList) {
        if(item != -1) {
          this.checkedAndroid.push(item);
          this.androidHandleCheckedChange(this.checkedAndroid)
        }else if(item == -1){
          this.checkedAndroid = this.channelListAndroid;
          this.checkAllAndroid = true;
        }else if(this.checkedAndroid.length == 0){
          this.checkAllAndroid = false;
        }
      }
      if(this.iconForm.androidChannelList.length == 0) {
        this.checkAllAndroid = false;
      }
    },

    summit() {
      if(!this.iconForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '名称不能为空',
          type: 'warning'
        });
        return false
      }
      if (this.jumpType != 3 && !this.iconForm.jumpUrl) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'url不能为空',
          type: 'warning'
        });
        return false
      }
      if (this.jumpType != 3 && !urlReg.test(this.iconForm.jumpUrl)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'URL地址输入有误',
          type: 'warning'
        });
        return false
      }
      if(!this.iconForm.showOrder) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '礼物图片不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.checkedIos.length == 0 && this.checkedAndroid.length == 0 && this.checkedHm.length == 0){
        this.$message({
          showClose: true,
          duration: 1000,
          message: '至少选择一个渠道',
          type: 'warning'
        });
        return;
      }
      this.loading = true
      // let platformChannels = [];
      // if(this.checkedIos.length == this.channelListIos.length && this.checkedAndroid.length == this.channelListAndroid.length) {
      //   platformChannels.push('-1||-1');
      // }else{
      //   if(this.checkedIos.length === this.channelListIos.length) {
      //     platformChannels.push('2||-1');
      //   }else if(this.checkedIos.length > 0){
      //     platformChannels = platformChannels.concat( this.iosArray );
      //   }
      //   if(this.checkedAndroid.length === this.channelListAndroid.length) {
      //     platformChannels.push('1||-1');
      //   }else if(this.checkedAndroid.length > 0){
      //     platformChannels = platformChannels.concat( this.androidArray );
      //   }
      // }
      //
      // if(this.iconForm.showUid && this.iconForm.showUid != ''){
      //   this.iconForm.showUid = this.iconForm.showUid.replace(/\r\n/g,",");
      //   this.iconForm.showUid = this.iconForm.showUid.replace(/\n/g,",");
      //   this.iconForm.showUid = this.iconForm.showUid.replace(/，/g,",");
      // }

      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.iconForm.id);
      } else {
        param.append('id', 0);
      }
      param.append('name', this.iconForm.name);
      param.append('showOrder', this.iconForm.showOrder);
      // param.append('showPlatform', (this.checkedIos.length > 0 && this.checkedAndroid.length > 0) ? -1 : (this.checkedIos.length > 0 && this.checkedAndroid.length == 0) ? 2 : (this.checkedIos.length == 0 && this.checkedAndroid.length > 0) ? 1 : '');
      param.append('urlType', this.jumpType);
      param.append('jumpUrl', this.jumpType == 3?this.appUrl:this.iconForm.jumpUrl);
      // param.append('platformChannel', platformChannels.toString());
      param.append('provinces', this.selectProvinces.toString());
      param.append('citys', this.selectCitys.toString());
      param.append('file', this.files);

      if(this.checkedIos.length == this.channelListIos.length) {
        param.append('iosChannelArr', ['-1']);
      }else {
        param.append('iosChannelArr', this.iosArray);
      }
      if(this.checkedAndroid.length == this.channelListAndroid.length) {
        param.append('androidChannelArr', ['-1']);
      }else {
        param.append('androidChannelArr', this.androidArray);
      }
      if(this.checkedHm.length == this.channelListHm.length) {
        param.append('harmonyChannelArr', ['-1']);
      }else {
        param.append('harmonyChannelArr', this.hmArray);
      }

      imgPostFormData(addOrUpdateHomeIcon, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }
  },
  mounted() {
    this.getChannelListAll();
    if(this.iconForm.areaList){
      if(this.iconForm.areaList.length == 0){
        this.checkArea = true;
      }else {
        for(let a=0; a<this.iconForm.areaList.length; a++){
          if(this.iconForm.areaList[a].province != -1){
            this.selectProvinces.push(this.iconForm.areaList[a].province)
          }
          if(this.iconForm.areaList[a].city != -1){
            this.selectCitys.push(this.iconForm.areaList[a].city)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
  .showBox {
    width: 540px;
    margin-left: 8px;
    border: 1px solid #ededed;
    padding: 24px 0 24px 32px;
  }
  .item-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }
.citys{
  display: flex;
  align-items: center;
  /*float: left;*/
  height: 24px;
  background: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  padding: 2px 8px;
  font-size: 14px;
  margin: 0 10px 6px 0px;
}
.citys i{
  width:16px;
  height: 16px;
  cursor: pointer;
  padding-left: 8px;
}
.check{
  padding-left: 6px;
}
li {
  list-style: none;
}
</style>
